function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import React from "react";
import { breakpoints } from "../../../../settings";
import getSrcSetPicture, { ImageType } from "../helpers/getSrcSetPicture";
export var SourceMediaBreakpoints = {
  SMALL: "(max-width:".concat(breakpoints.medium - 1, "px)"),
  MEDIUM: "(min-width: ".concat(breakpoints.medium, "px) and (max-width: ").concat(breakpoints.large - 1, "px)"),
  LARGE: "(min-width: ".concat(breakpoints.large, "px)")
};
var PictureSource = function PictureSource(_ref) {
  var imgData = _ref.imgData,
    sourceBreakpoint = _ref.sourceBreakpoint,
    imageType = _ref.imageType;
  var sourceType;
  switch (imageType) {
    case ImageType.WEBP:
      sourceType = "image/webp";
      break;
    case ImageType.AVIF:
      sourceType = "image/avif";
      break;
    default:
      sourceType = undefined;
  }
  return /*#__PURE__*/React.createElement("source", {
    media: sourceBreakpoint,
    srcSet: getSrcSetPicture(imgData, imageType),
    width: _typeof(imgData) === "object" ? imgData.width : undefined,
    height: _typeof(imgData) === "object" ? imgData.height : undefined,
    type: sourceType
  });
};
export default PictureSource;